import { Col, Row, message } from 'antd';
import { Formik } from 'formik';
import { Form, Input } from 'formik-antd';
import React from 'react';
import { useDispatch } from 'react-redux';
import * as Yup from 'yup';
import { userLogin } from 'store/authSlice';
import { LoginInput } from 'atoms';
import { IconLabel } from 'components';
import * as styled from './AuthFormStyle';
import { setupFCMNotifications } from '../../firebase/setupFCM';

const { LoginContainer, StyledSubmitButton } = styled;

const FormSchema = Yup.object({
	username: Yup.string().required().label('Login ID'),
	password: Yup.string().required().label('Password'),
});

let initialValues = {
	username: undefined,
	password: undefined,
};

if (process.env.NODE_ENV === 'development') {
	/**
	 * On development set login form details prefilled with data
	 */
	initialValues = {
		username: 'ripplr',
		password: 'ripplr',
	};
}

function LoginForm() {
	const dispatch = useDispatch();

	function handleSubmit(values, { setErrors, setSubmitting }) {
		return dispatch(userLogin(values, setErrors))
			.then(async () => {
				console.log('Login api done');
				/**
				 * To get the ACL data, doing hard refresh
				 */
				if (Notification.permission === 'default') {
					const result = await Notification.requestPermission();
					if (result === 'granted') {
						await setupFCMNotifications();
					}
				} else if (Notification.permission === 'granted') {
					await setupFCMNotifications();
				}
				window.location = `${window.origin}/dashboard`;
			})
			.catch((e) => {
				console.log('Login form catch', e);

				// Handle location permission denied error
				if (e.message === 'LOCATION_PERMISSION_DENIED') {
					// Error message already shown in getLoginHeaders, just prevent form submission
					return;
				}

				// Handle other login errors
				if (e.response?.data?.error?.message) {
					message.error(e.response.data.error.message);
				} else {
					message.error('Login failed. Please try again.');
				}
			})
			.finally(() => {
				console.log('Login form finally');
				setSubmitting(false);
			});
	}

	console.log('FormSchema', FormSchema);

	return (
		<LoginContainer>
			<Formik
				enableReinitialize
				initialValues={initialValues}
				// validationSchema={FormSchema}
				onSubmit={handleSubmit}
			>
				{({ isSubmitting }) => (
					<Form layout="vertical">
						<Row gutter={8} justify="space-between">
							<Col span={24}>
								<LoginInput
									name="username"
									label={<IconLabel label="Login ID" />}
									className="email-field"
								>
									<Input name="username" />
								</LoginInput>
							</Col>
						</Row>
						<Row gutter={8} justify="space-between">
							<Col span={24}>
								<LoginInput
									name="password"
									label={<IconLabel label="Password" />}
									className="password-field"
								>
									<Input.Password name="password" />
								</LoginInput>
							</Col>
						</Row>
						<Row gutter={8} justify="space-between">
							<Col span={24}>
								<StyledSubmitButton disabled={isSubmitting} id="login-btn">
									Login
								</StyledSubmitButton>
							</Col>
						</Row>
					</Form>
				)}
			</Formik>
		</LoginContainer>
	);
}

export default LoginForm;
